// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ChooseLayout_wrapper__2Bvg8","squares":"ChooseLayout_squares__2Q2rx","select":"ChooseLayout_select__3JU6y"};